export default __webpack_public_path__ + "static/media/lease-guide-costs.d08d6ef8.svg";